import {
  BoxSpg,
  useReactHookForm,
  DividerSpg,
  ButtonSpg,
  AsyncCallArgs,
  fillNonNullValues,
  useAsyncCall,
  SimpleConfirmDialog,
  AlertSpg,
} from "@duosoftbg/nacid-components";
import { FormProvider } from "react-hook-form";
import { createARUniEntryRequestSchema } from "../../../../../../yup/requestSchemas";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Button, Typography } from "@mui/material";
import RequestApplicantSection from "./sections/RequestApplicantSection";
import RequestUniDiplomaSection from "./sections/RequestUniDiplomaSection";
import RequestRecognizedSection from "./sections/RequestRecognizedSection";
import RequestNotesSection from "./sections/RequestNotesSection";
import { saveARUniEntryRequest, saveAndPublishARUniEntryRequest } from "../../../../../../axios/api/services";
import { initialARUniversityEntryRequest } from "../../../../../../init/initRequests";
import { useEffect, useState } from "react";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { useNavigate } from "react-router-dom";
import RequestRelatedRecognitionSection from "./sections/RequestRelatedRecognitionSection";
import { ARUniEntryRequestStatus } from "../../../../../../utils/constants";

const ARUniEntryRequestForm = ({ formInitialData }) => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();
  const navigate = useNavigate();
  const [openConfirm, setOpenConfirm] = useState(false);

  const loggedUser = useAppSelector((state) => {
    return state.AppData.loggedUser;
  });

  const { methods } = useReactHookForm<any>({
    defaultValues: formInitialData,
    validationSchema: createARUniEntryRequestSchema,
  });

  const setValue = methods.setValue;
  const id = formInitialData.id;

  useEffect(() => {
    if (!id && loggedUser.data?.userDetails?.representedUniversity) {
      setValue("recognizingUniversity.universityIdentifier", loggedUser.data?.userDetails?.representedUniversity);
    }
  }, [id, loggedUser, setValue]);

  const onSave = (values) => {
    commonSave(values, false);
  };

  const onSaveAndPublish = (values) => {
    commonSave(values, true);
    setOpenConfirm(false);
  };

  const commonSave = (values, isSaveAndPublish) => {
    const asyncSave: AsyncCallArgs = {
      withGlobalBackdrop: true,
      promise: isSaveAndPublish ? saveAndPublishARUniEntryRequest(values) : saveARUniEntryRequest(values),
      reactHooksForm: { methods },
      onSuccess: (response) => {
        if (isSaveAndPublish) {
          navigate("/ar-uni-entry-request/list/view?id=" + response);
        } else {
          const updatedResponseData = { ...initialARUniversityEntryRequest };
          fillNonNullValues(response, updatedResponseData);

          methods.reset(updatedResponseData);
        }
        toast.success(
          isSaveAndPublish
            ? t("m.arUniEntryRequest.saveAndPublish.data.success")
            : t("m.arUniEntryRequest.save.data.success"),
        );
      },
    };
    asyncCall(asyncSave);
  };

  const isRecordAccepted = () => {
    if (formInitialData && formInitialData.requestStatus?.id === ARUniEntryRequestStatus.ACCEPTED) {
      return true;
    }
    return false;
  };

  return (
    <BoxSpg>
      <FormProvider {...methods}>
        {isRecordAccepted() && <AlertSpg severity={"warning"}>{t("m.warning.edit.accepted.register.record")}</AlertSpg>}
        <form>
          <RequestApplicantSection />
          <RequestUniDiplomaSection />
          <RequestRecognizedSection />
          <RequestRelatedRecognitionSection />
          <RequestNotesSection />
        </form>
        <DividerSpg my={4} />
        <BoxSpg>
          <Typography align={"right"}>
            {!isRecordAccepted() && (
              <Button
                type={"button"}
                variant={"outlined"}
                onClick={methods.handleSubmit(onSave, (errors) => {
                  console.log(errors);
                  toast.error(t("m.validation.errors.present"));
                })}
              >
                {t("l.btn.arUniEntryRequest.saveData")}
              </Button>
            )}
            <ButtonSpg type={"button"} variant={"contained"} ml={4} onClick={() => setOpenConfirm(true)}>
              {t("l.btn.arUniEntryRequest.saveAndPublishData")}
            </ButtonSpg>
          </Typography>
        </BoxSpg>

        <SimpleConfirmDialog
          open={openConfirm}
          setOpen={setOpenConfirm}
          alertType={"warning"}
          alertText={"m.arUniEntryRequest.saveAndPublish.request.warn"}
          dialogTitleText={"t.arUniEntryRequest.confirm.dialog"}
          onConfirm={methods.handleSubmit(onSaveAndPublish, (errors) => {
            console.log(errors);
            setOpenConfirm(false);
            toast.error(t("m.validation.errors.present"));
          })}
        />
      </FormProvider>
    </BoxSpg>
  );
};
export default ARUniEntryRequestForm;
